import { NavLink } from "react-router-dom";
import { routes } from "../routes/routeConfig";
import { X } from "lucide-react";

const Sidebar = ({ userRole = "student", open, setOpen }) => {
  return (
    <div className="bg-secondary">
      {/* Overlay (Mobile) */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed md:static z-50 top-0 left-0 h-full w-64 bg-secondary shadow-md transform transition-transform
        ${open ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
      >

        {/* Header */}
        <div className="flex items-center justify-between">

          <button className="md:hidden" onClick={() => setOpen(false)}>
            <X />
          </button>
        </div>

        {/* Menu */}
        <nav className="flex flex-col gap-1 p-3">
          {routes
            .filter(
              (r) =>
                r.showInSidebar &&
                (!r.role || r.role.includes(userRole))
            )
            .map((route) => {
              const Icon = route.icon;

              return (
                <NavLink
                  key={route.path}
                  to={route.path}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2 rounded-lg transition ${
                      isActive
                        ? "bg-primary/10 text-primary font-semibold"
                        : "text-gray-600 hover:bg-gray-100"
                    }`
                  }
                >
                  {Icon && <Icon className="w-5 h-5" />}
                  <span>{route.title}</span>
                </NavLink>
              );
            })}
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;